import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Select from 'react-select';
import API from '../../api/axios';
import FormHelperText from '@material-ui/core/FormHelperText';
import { useHydrate, useQuery } from 'react-query';

const SelectCities = React.memo(
  ({
    isMulti = false,
    onSelect,
    placeholder = 'انتخاب شهر',
    city,
    state,
    isDisabled = false,
    mostUse,
    isDest,
    width = '100%',
    height = 56,
    isClearable = true,
    error = false,
    hasLabel = false,
    ...rest
  }) => {
    const [cities, setCities] = useState(null);

    const loadCities = async () => {
      let filter = Array();
      mostUse !== undefined && filter.push(`mostUse=${mostUse}`);
      isDest !== undefined && filter.push(`isDest=${isDest}`);
      !!state && filter.push(`state=${state}`);
      // let query = filter.join('&');
      // const url = `/api/v1/admin/city/list?${query}`;
      try {
        // const { data } = await API.get(url);
        const respone = await fetch('/cities.json');
        const data = await respone.json();
        if (state) {
          const res = data.filter((item) => item.state._id === state);
          return res;
        }
        return data;
        setCities(data);
      } catch (err) {
        console.error(err);
      }
    };
    const handleSelectCity = (city) => {
      onSelect(city);
    };
    const customStyles = {
      menu: (provided, state) => ({
        ...provided,
        zIndex: 100000,
      }),
      control: (provided, state) => ({
        ...provided,
        height,
        width,
        border: `1px solid ${error ? 'red' : '#ccc'}`,
      }),
    };

    // useEffect(() => {
    //   loadCities();
    // }, [state]);

    const { data, isLoading } = useQuery(
      ['loadCities', state],
      () => loadCities(),
      {
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 60 * 24 * 30,
        cacheTime: Infinity,
      }
    );
    return !isLoading ? (
      <>
        <Select
          options={data.map((city) => ({
            label: city.title,
            value: city._id,
          }))}
          isMulti={isMulti}
          isSearchable={true}
          placeholder={placeholder}
          value={city}
          onChange={(option) => handleSelectCity(option)}
          noOptionsMessage={() => 'شهری یافت نشد'}
          isDisabled={isDisabled}
          isClearable={isClearable}
          styles={customStyles}
          {...rest}
        />
        {city && hasLabel && (
          <label
            style={{
              position: 'absolute',
              top: -8,
              right: 10,
              fontSize: 12,
              color: 'gray',
              background: '#fff',
              padding: '0 5px',
            }}
          >
            {placeholder}
          </label>
        )}
        <FormHelperText error={error ? true : false}>{error}</FormHelperText>
      </>
    ) : (
      <Skeleton height={height} animation="wave" variant="rect" width={width} />
    );
  }
);

export default SelectCities;
